import { render, staticRenderFns } from "./SpecialList.vue?vue&type=template&id=77233988&scoped=true&lang=html"
import script from "./SpecialList.vue?vue&type=script&lang=js"
export * from "./SpecialList.vue?vue&type=script&lang=js"
import style0 from "./SpecialList.vue?vue&type=style&index=0&id=77233988&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77233988",
  null
  
)

export default component.exports